import { Component, inject, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { InputText } from 'primeng/inputtext';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { Button } from 'primeng/button';
import { CustomerInformation, CustomerInformationList } from '../../models/customer-information.model';
import { Paginator } from 'primeng/paginator';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogCreateCustomerInformationComponent } from '../dialog-create-customer-information/dialog-create-customer-information.component';
import { Popover } from 'primeng/popover';
import { BaseComponent } from '../../../../shared/components/base/base.component';
import { CustomerInformationService } from '../../services/customer-information.service';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-customer-information',
  imports: [
    TableModule,
    InputText,
    IconField,
    InputIcon,
    Button,
    Paginator,
    Popover,
    TranslatePipe,
    LoadingComponent,
    ReactiveFormsModule,
    DatePipe
  ],
  providers: [DialogService],
  templateUrl: './customer-information.component.html',
  styleUrl: './customer-information.component.scss'
})
export class CustomerInformationComponent extends BaseComponent implements OnInit {
  data: CustomerInformationList;
  form: FormGroup;
  loading = true;

  fb = inject(FormBuilder);
  dialogService = inject(DialogService);
  customerInformationService = inject(CustomerInformationService);

  ngOnInit(): void {
    this.form = this.fb.group({ search: [''] });
    this.form.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
      this.fetchData();
    });
    this.fetchData();
  }

  fetchData(e?: any): void {
    const param = {
      page: e ? e.page + 1 : 1,
      pageSize: e ? e.rows : this.rows,
      ...this.form.value
    };
    if (e) {
      this.first = e.first ?? 0;
    }
    this.loading = true;
    this.customerInformationService.getCustomer(param).subscribe({
      next: res => {
        this.data = res.data;
        this.first = e?.first ?? 0;
        this.loading = false;
      },
      error: () => {
        this.data = { content: [] } as any;
        this.loading = false;
      }
    });
  }

  clearSearch(): void {
    this.form.get('search')?.setValue('');
  }

  onCreate(): void {
    const ref = this.dialogService.open(DialogCreateCustomerInformationComponent, {
      styleClass: 'p-dialog-maximized p-dialog-content-footer',
      showHeader: false
    });
    ref?.onClose.subscribe(() => this.fetchData());
  }

  goView(customer: CustomerInformation): void {
    const ref = this.dialogService.open(DialogCreateCustomerInformationComponent, {
      styleClass: 'p-dialog-maximized p-dialog-content-footer',
      showHeader: false,
      data: { id: customer.id }
    });
    ref?.onClose.subscribe(() => this.fetchData());
  }

  goMakeOPD(customer: CustomerInformation): void {
    this.dialogService.open(DialogCreateCustomerInformationComponent, {
      styleClass: 'p-dialog-maximized p-dialog-content-footer',
      showHeader: false,
      data: { id: customer.id, action: 'makeOPD' }
    });
  }
}
